document.addEventListener("alpine:init", () => {
  Alpine.data("VariantUI", () => ({
    get totalPrice() {
      if (!this.currentVariant) return 0;
      return (this.currentVariant.price || 0) * (this.qty || 1);
    },
    variants: [],
    selectedVariantId: null,
    currentVariant: null,
    qty: 1,
    loading: false,

    init() {
      this.$nextTick(() => {
        this.variants = JSON.parse(this.$refs.variants.textContent || "[]");
        if (this.variants.length) {
          const urlParams = new URLSearchParams(window.location.search);
          const urlVariantId = urlParams.get("variant");
          let v = null;
          if (urlVariantId) {
            v = this.variants.find(
              (variant) =>
                String(variant.id) === urlVariantId && variant.available
            );
          }
          if (!v) {
            v =
              this.variants.find((variant) => variant.available) ||
              this.variants[0];
          }
          this.selectedVariantId = v.id;
          this.updateVariant(false);
        }
      });
    },

    // Selection
    setVariant(id) {
      this.selectedVariantId = id;
      this.updateVariant(true);
    },

    // Refresh URL y currentVariant
    updateVariant(pushUrl = true) {
      this.currentVariant =
        this.variants.find(
          (v) => v.id == this.selectedVariantId && v.available
        ) || null;

      if (this.currentVariant && pushUrl) {
        const sp = new URLSearchParams(location.search);
        sp.set("variant", this.currentVariant.id);
        history.replaceState({}, "", `${location.pathname}?${sp}`);
      }
    },

    // Price
    money(cents) {
      return ((cents || 0) / 100).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    // Add to cart
    async addToCart() {
      if (!this.currentVariant) return;
      this.loading = true;
      await Alpine.store("cart").add({
        id: this.currentVariant.id,
        quantity: this.qty || 1,
      });
      this.loading = false;
      this.qty = 1;
    },
  }));
});
